import { useTranslation } from 'react-i18next';
import { NativeButton } from '../common/NativeButton';
import type { ResumeHandoffClaimResult } from '../../lib/resume-handoff';

export function HandoffResumeImportDraft({ draft, sourceChanged, disabled, onReview }: {
  draft: ResumeHandoffClaimResult | null;
  sourceChanged: boolean;
  disabled: boolean;
  onReview: () => void;
}) {
  const { t } = useTranslation('seeker');
  if (!draft) return null;
  return <section style={{ padding: 16, marginBlockEnd: 16, borderRadius: 16, backgroundColor: 'var(--tabbio-surface)' }}>
    <p style={{ color: 'var(--text-primary)' }}>{t('cv.importEvidence.resumeDraft')}</p>
    <p dir="auto" style={{ color: 'var(--text-secondary)' }}>{draft.parsed.name || draft.parsed.title}</p>
    {sourceChanged ? <p>{t('cv.importEvidence.sourceChanged')}</p> : <NativeButton title={t('cv.importEvidence.resumeReview')} size="sm" variant="outline" disabled={disabled} onPress={onReview} />}
  </section>;
}
